import { karateR0Fetch } from "./karateR0ApiClient.js";

export async function fetchPublicInstructors() {
  const { response, body } = await karateR0Fetch("/instructors");
  return { ok: response.ok, status: response.status, body };
}

export async function fetchPublicInstructor(id) {
  const { response, body } = await karateR0Fetch(`/instructors/${id}`);
  return { ok: response.ok, status: response.status, body };
}

export async function fetchAdminInstructors(params = {}) {
  const query = new URLSearchParams();
  if (params.search) query.set("search", params.search);
  if (params.dojoId) query.set("dojoId", params.dojoId);
  if (params.visibility) query.set("visibility", params.visibility);
  const qs = query.toString();
  const { response, body } = await karateR0Fetch(`/admin/instructors${qs ? `?${qs}` : ""}`);
  return { ok: response.ok, status: response.status, body };
}

export async function fetchInstructorCandidates() {
  const { response, body } = await karateR0Fetch("/admin/instructors/candidates");
  return { ok: response.ok, status: response.status, body };
}

export async function fetchDojosForSelect() {
  const { response, body } = await karateR0Fetch("/admin/dojos?status=ACTIVE");
  if (!response.ok) return { ok: false, status: response.status, body };
  return {
    ok: true,
    status: response.status,
    body: {
      dojos: (body.dojos ?? []).map((d) => ({ id: d.id, name: d.name, city: d.city })),
    },
  };
}

export async function createInstructorProfile(payload) {
  const { response, body } = await karateR0Fetch("/admin/instructors", {
    method: "POST",
    body: JSON.stringify(payload),
  });
  return { ok: response.ok, status: response.status, body };
}

export async function updateInstructorProfile(id, payload) {
  const { response, body } = await karateR0Fetch(`/admin/instructors/${id}`, {
    method: "PATCH",
    body: JSON.stringify(payload),
  });
  return { ok: response.ok, status: response.status, body };
}

export async function setInstructorVisibility(id, isPublic) {
  const { response, body } = await karateR0Fetch(`/admin/instructors/${id}/visibility`, {
    method: "PATCH",
    body: JSON.stringify({ isPublic }),
  });
  return { ok: response.ok, status: response.status, body };
}
